export const COLORS = {
  backgroundColor: "#EBEBEB",
  primaryAppWhite: "#F5F5F5",
  secondaryAppWhite: "#EBEBEB",
  primaryAppGray: "#B6B7BF",
  primaryAppBlack: "#1D1D26",
  primaryAppBlue: "#3356FF",
  secondaryAppBlue: "#5975FE",
  primaryWhite: "#FEFEFE",
  secondaryWhite: "#F3F3F3",
  thirdWhite: "#F2F2F2",
  forthWhite: "#FFFFFF",
  secondaryBlack: "#101010",
  primaryGray: "#A2A5B1",
  secondaryGray: "#8A8C91",
  thirdGray: "#DADCE0",
  forthGray: "#777777",
  fifthGray: "#A2A5B1",
  rainbowIndigo: "#293462",
  cornflowerBlue: "#293462",
  veryPaleOrange: "#FBDCBD",
  terraCotta: "#E36F61",
  thirdBlack: "#1D1B23",
  forthBlack: "#293462",
  fifthBlack: "#2934624D",
  sixthBlack: "#101010",
  newOrange: "#E65847",
  gradientBlueColors:
    "transparent linear-gradient(189deg, #6C9EFC 0%, #293462 100%) 0% 0% no-repeat padding-box",
  secondarygradientBlueColors:
    "transparent linear-gradient(257deg, #6C9EFC 0%, #09456E 100%) 0% 0% no-repeat padding-box",
  gradientGrayColors:
    "transparent linear-gradient(257deg, #A2A5B1 0%, #8A8C91 100%) 0% 0% no-repeat padding-box",
  primaryGreen: "#3AB124",
  primaryYellow: "#FFD939",
  gradientRedColors:
    "transparent linear-gradient(259deg, #FBDCBD 0%, #E36F61 100%) 0% 0% no-repeat padding-box;",
};

export const FONTS = {
  montserrat: "'Montserrat', sans-serif",
  newsharp: "'Poppins', sans-serif",
  poppins: "'Poppins', sans-serif"
};

export const BOXSHADOW = {
  containerBoxShadow: "-5px 5px 10px #2934624D",
  headerBoxShadow: "0 5px 10px #2934624D",
  secondContainerBoxShadow: "10px 10px 10px #0A21314D;",
  discountCardsBoxShadow: "0px 4px 10px #29346233;",
};

export const WIDTH = {
  mediumWidth: "max-width: 1600px",
  smallWidth: "max-width: 1400px",
  tabletWidth: "max-width: 860px",
};
